import React, { useContext, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import styled from "styled-components";
import { HiddenRadioInput, RadioMark } from "../../Inputs/Radio";
import { FormFieldGroupContext } from "../FormFieldGroup";
import { FormFieldWrapper } from "../FormFieldWrapper";
import { GenericFormContext } from "../GenericFormContext";
/**
 * `FormRadio` is basically the same component as `InputRadio`, but it is connected to React Hook Form.
 * So it is meant to be used within a React Hook Form such as our `Form` component.
 */
export const FormRadio = (props) => {
    const { name, value, disabled = false, children, readOnly = false, fixedWidth, defaultChecked } = props;
    const { register, getValues, setValue } = useFormContext();
    const { editIsAllowed } = useContext(GenericFormContext);
    const isReadOnly = readOnly === true || editIsAllowed === false;
    const { disabled: disabledFromFormFieldGroup } = React.useContext(FormFieldGroupContext);
    const isDisabled = disabledFromFormFieldGroup || disabled;
    const formValue = getValues(name);
    useEffect(() => {
        if (formValue === undefined && defaultChecked) {
            // We intentionally use `setValue` instead of relying on the React/HTML `defaultChecked` property
            // https://gitlab.com/auviknetworks/javascript-libraries/iceberg-ui/-/merge_requests/963
            setValue(name, value);
        }
    }, [formValue, defaultChecked, name, value, setValue]);
    return (React.createElement(FormFieldWrapper, { name: name, pb: 0, fixedWidth: fixedWidth },
        React.createElement(FormRadioLabel, { disabled: isDisabled },
            React.createElement(HiddenRadioInput, Object.assign({ type: "radio", value: value, className: isReadOnly ? "readOnly" : "" }, register(name, Object.assign({}, (isDisabled ? { disabled: true } : {}))), (isReadOnly
                ? {
                    onChange: (evt) => {
                        evt.preventDefault();
                    },
                    onClick: (evt) => {
                        evt.preventDefault();
                    },
                }
                : {}))),
            React.createElement(RadioMark, { "data-testid": "radio-mark" }),
            React.createElement(FormRadioText, null, children))));
};
const FormRadioLabel = styled.label `
  cursor: pointer;
  display: flex;
  color: ${({ disabled, theme }) => (disabled ? theme.colors.radioColors.disabledLabel : "inherit")};
  position: relative;
  padding: ${({ theme }) => `${theme.space[1]}px`} 0;
`;
const FormRadioText = styled.span `
  margin-left: ${({ theme }) => `${theme.space[2]}px`};
`;
